<template>
	<div class="app-container gamesMember">
		<!-- <el-button type="primary" icon="el-icon-edit" @click="handleQuery">审批用户</el-button> -->
		<el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="box_form mt10">
			<el-form-item label="姓名" prop="userName">
				<el-input v-model="queryParams.userName" placeholder="请输入姓名" clearable @keyup.enter.native="handleQuery"
					@change="$forceUpdate()"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="mobile">
				<el-input v-model="queryParams.mobile" placeholder="请输入手机号码" clearable @keyup.enter.native="handleQuery"
					@change="$forceUpdate()"></el-input>
			</el-form-item>
			<el-form-item label="审核状态" prop="isCheck">
				<el-select filterable v-model="queryParams.isCheck" placeholder="审核状态" clearable
					@change="$forceUpdate()">
					<el-option v-for="(item, index) in status" :key="index" :label="item.name" :value="item.value" />
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
				<el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
			</el-form-item>
		</el-form>

		<el-table v-loading="loading" element-loading-text="加载中" :data="list">
			<el-table-column label="编号" align="center" type="index" width="50" />
			<el-table-column label="头像" align="center" prop="nickName">
				<template slot-scope="scope">
					<el-avatar :src="scope.row.avatarUrl" class="mr10"></el-avatar>
				</template>
			</el-table-column>
			<el-table-column label="姓名" align="center" prop="userName" />
			<el-table-column label="手机号码" align="center" prop="mobile" />
			<el-table-column label="性别" align="center" prop="sex">
				<template slot-scope="scope">
					<span>{{ scope.row.sex == '0' ? '男' : '女' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="所在省市" align="center" prop="cityName" />
			<el-table-column label="审核状态" align="center" prop="memberType">
				<template slot-scope="scope">
					<span class="statusTag warn" v-if="scope.row.isCheck == '1'"> 待审核 </span>
					<span class="statusTag danger" v-if="scope.row.isCheck == '2'"> 审核拒绝 </span>
					<span class="statusTag success" v-if="scope.row.isCheck == '3'"> 审核通过 </span>
				</template>
			</el-table-column>
			<el-table-column label="报名时间" align="center" prop="createTime"></el-table-column>
			<el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="250">
				<template slot-scope="scope">
					<el-button size="small" plain type="primary" @click="handleDtl(scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
			:limit.sync="queryParams.pageSize" @pagination="_getList" />

		<el-dialog title="用户信息" :visible.sync="dialogShow" width="500px" append-to-body>
			<div style="line-height: 40px">
				<el-row :gutter="24">
					<el-col :span="12">昵称：{{ userInfo.nickName }}</el-col>
					<el-col :span="12">姓名：{{ userInfo.userName }}</el-col>
				</el-row>
				<el-row :gutter="24">
					<el-col :span="12">性别：{{ userInfo.sex == '0' ? '男' : '女' }}</el-col>
					<el-col :span="12">手机号：{{ userInfo.mobile }}</el-col>
				</el-row>
				<el-row :gutter="24">
					<el-col :span="12">所在城市：{{ userInfo.cityName }}</el-col>
					<el-col :span="12">生日：{{ userInfo.birthday }}</el-col>
				</el-row>
			</div>
			<div class="applyCondition">
				审核状态
			</div>
			<div class="applyDetail">
				<div>
					<span class="statusTag warn" v-if="userInfo.isCheck == '1'"> 待审核 </span>
					<span class="statusTag danger" v-if="userInfo.isCheck == '2'"> 审核拒绝 </span>
					<span class="statusTag success" v-if="userInfo.isCheck == '3'"> 审核通过 </span>
				</div>
				<div v-if="userInfo.isCheck == '2'">
					拒绝原因 ：{{userInfo.checkRemark}}
				</div>
			</div>
			<div class=" applyCondition" v-if="userInfo.applyAskOf">
					报名条件
				</div>
				<div class="applyDetail" v-if="userInfo.applyAskOf">
					<div v-for="item in userInfo.applyAskOf">
						<div v-if="item.name != '上传图片'">
							{{item.value}} : {{item.inputVal}}
						</div>
						<div style="display: flex;align-items: center;" v-else>
							<div style="margin-right: 10px;">{{item.value}} : </div>
							<el-image fit="contain" class="tableImg" :src="item.inputVal"
							  :preview-src-list="[item.inputVal]" >
							  <div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							  </div>
							</el-image>
						</div>
					</div>
				</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as API_Game from "@/api/sportManage/game";

	export default {
		name: "gamesMember",
		props: ["id", "name"],
		data() {
			return {
				activeName: 'all',
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				// 1:未审核，2：审核失败，3：审核成功
				status: [{
						value: '',
						name: "全部",
					},
					{
						value: '1',
						name: "未审核",
					},
					{
						value: '2',
						name: "审核拒绝",
					},
					{
						value: '3',
						name: "审核成功",
					},
				],
				list: [],
				total: 0,
				loading: false,
				dialogShow: false,
				userInfo: {}
			};
		},
		watch: {
			name: {
				handler(newVal, oldVal) {
					console.log(this.id)
					if (newVal == 'list') {
						this.queryParams.gameId = this.id
						this._getList()
					}
				},
			}
		},
		created() {},
		methods: {
			handleQuery() {
				this.queryParams.startTime = this.queryParams.time ? this.queryParams.time[0] : "";
				this.queryParams.endTime = this.queryParams.time ? this.queryParams.time[1] : "";
				this.queryParams.pageNum = 1;
				this._getList();
			},
			resetQuery() {
				this.$refs["queryForm"].resetFields();
				this.queryParams.startTime = ''
				this.queryParams.endTime = ''
				this._getList();
			},

			handleDtl(row) {
				this.userInfo = row
				this.dialogShow = true
			},

			// 接口-成员列表
			_getList() {
				this.loading = true
				API_Game.gameMember(this.queryParams).then((res) => {
					console.log(res.data);
					this.loading = false
					this.total = res.data.total;
					this.list = res.data.list;
					for (let i = 0; i < this.list.length; i++) {
						this.list[i].applyAskOf = JSON.parse(this.list[i].applyAskOf)
						console.log(this.list[i].applyAskOf)
					}
				}).catch((err) => {

				});
			}
		},
	};
</script>

<style lang="scss">
	.gamesMember {
		padding: 0 10px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

	}
</style>


<style lang="scss">
	@import "../../../../assets/styles/common.scss";

	.applyCondition {
		font-weight: 700;
		font-style: normal;
		color: #7F7F7F;
		margin-top: 12px;
		border-bottom: #F3F3F3 0.5px solid;
		padding-bottom: 8px;
	}

	.applyDetail {
		margin-top: 10px;
	}
	
	.applyDetail div {
		margin-bottom : 5px;
	}
</style>